enum Entities {
    PAYABLES = "PAYABLES",
    RECIPIENTS = "RECIPIENTS",
}

export default Entities;